import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import ReactionView from '@Components/Results/reactions/ReactionView';
import StructureModel from '@Components/Results/structure/structure-model.service';
import ReferenceCitationDetails from './ReferenceCitationDetails';

import '@Components/Results/reactions/Reaction.scss';
import './ReactionReferencePreview.scss';

function toStructureModels(structures = [], metadata = {}, reaction = {}) {
  const normalizedStructures = Array.isArray(structures) ? structures : [];
  const databaseId = reaction?.databaseId || metadata?.databaseId;
  const index = reaction?.index;

  return normalizedStructures.map(
    (structure) =>
      new StructureModel({
        ...structure,
        databaseId: structure?.databaseId || databaseId,
        index: structure?.index || index,
      })
  );
}

function ReactionReferencePreview({ index, reaction = {}, metadata = {}, onDocumentDetailsClick }) {
  const reactants = useMemo(() => toStructureModels(reaction?.reactants, metadata, reaction), [metadata, reaction]);
  const products = useMemo(() => toStructureModels(reaction?.products, metadata, reaction), [metadata, reaction]);
  const reactionId = reaction?.id ? String(reaction.id) : '';
  const referencedCitation = reaction?.referencedCitation;
  const hasReactionStructures = !isEmpty(reactants) || !isEmpty(products);
  const reactionMetadata = useMemo(
    () => ({
      ...metadata,
      databaseId: reaction?.databaseId || metadata?.databaseId,
    }),
    [metadata, reaction]
  );

  return (
    <section className="reaction-reference-preview" data-e2e="reaction-reference-preview" data-testid="reaction-reference-preview">
      <h4 className="u-els-margin-bottom-2x">Reference preview</h4>
      <p className="u-els-margin-bottom-1o2">Reference {index > 0 ? index : ''}</p>
      {hasReactionStructures && (
        <div className="reaction-reference-preview__reaction-row u-els-margin-bottom-2x">
          <ReactionView
            metadata={reactionMetadata}
            reactants={reactants}
            products={products}
            zoom={0}
            showToolbar={false}
            reactionId={reactionId}
          />
        </div>
      )}
      {reactionId && <p className="u-els-margin-bottom">Reaction ID: {reactionId}</p>}
      {!referencedCitation?.title && reaction?.reaction && <p className="u-els-font-size-body-large">{reaction.reaction}</p>}
      {referencedCitation && (
        <ReferenceCitationDetails
          index={index}
          citation={referencedCitation}
          onDocumentDetailsClick={onDocumentDetailsClick}
          metadata={metadata}
          showFeedback={false}
        />
      )}
    </section>
  );
}

ReactionReferencePreview.propTypes = {
  index: PropTypes.number,
  reaction: PropTypes.object,
  metadata: PropTypes.object,
  onDocumentDetailsClick: PropTypes.func.isRequired,
};

export default ReactionReferencePreview;
